var map = {
	"./ico-bag.png": 70182,
	"./ico-bag.svg": 21370,
	"./ico-bars.svg": 30669,
	"./ico-bulb.svg": 31294,
	"./ico-campaign.png": 5663,
	"./ico-campaing.svg": 54749,
	"./ico-chip.svg": 169,
	"./ico-flask.svg": 68385,
	"./ico-hammer.png": 90755,
	"./ico-hammer.svg": 90584,
	"./ico-heart.png": 62223,
	"./ico-heart.svg": 57424,
	"./ico-lens.svg": 48046,
	"./ico-mountain.svg": 75892,
	"./ico-people.svg": 67307,
	"./ico-puzzle.png": 99082,
	"./ico-puzzle.svg": 78508,
	"./ico-stadistics.svg": 36351,
	"./ico-statistics.png": 80935,
	"./ico-store.png": 51380,
	"./ico-store.svg": 7255,
	"./ico-stroke-architecture.png": 23229,
	"./ico-stroke-cases.png": 38851,
	"./ico-stroke-cube.png": 64105,
	"./ico-stroke-flow.png": 23703,
	"./ico-stroke-microservices.png": 37638,
	"./ico-stroke-trees.png": 61379,
	"./ico-wallet.svg": 23014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8203;